/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHandRash = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12.5 1c.89 0 1.668.466 2.111 1.165A2.5 2.5 0 0 1 18 4.5v.55a2.5 2.5 0 0 1 3 2.45v9h-2v-9a.5.5 0 0 0-1 0V11h-2V4.5a.5.5 0 0 0-1 0V11h-2V3.5a.5.5 0 0 0-1 0V11h-2V4.5a.5.5 0 0 0-1 0v6.814l.028.015c.87.385 1.96 1.027 2.844 1.94.89.918 1.628 2.17 1.628 3.731h-2c0-.888-.411-1.666-1.063-2.339-.658-.678-1.51-1.19-2.218-1.503-.511-.226-1.031-.575-1.421-1.095l-.036-.047-1.24-2.149a.58.58 0 0 0-.791-.212.556.556 0 0 0-.234.716c.707 1.525 1.898 4.01 2.86 5.614.748 1.246 1.422 2.234 2.274 2.926.812.66 1.837 1.089 3.37 1.089 1.755 0 2.338 0 2.564-.003.097-.001.1-.003.102-.003l.295-.017.019-.001h.018c.9 0 1.61-.177 2.094-.599.458-.4.907-1.195.907-2.877h2c0 2.028-.551 3.473-1.593 4.383-1.004.877-2.277 1.088-3.369 1.093l-.188.01a2.975 2.975 0 0 1-.26.01C15.348 22 14.744 22 13 22c-1.967 0-3.443-.571-4.63-1.536-1.149-.933-1.976-2.195-2.728-3.45-1.024-1.705-2.254-4.281-2.96-5.801a2.557 2.557 0 0 1 1.049-3.29A2.578 2.578 0 0 1 7 8.508V4.5a2.5 2.5 0 0 1 3.387-2.335A2.497 2.497 0 0 1 12.5 1z" />
        <path d="M15 17a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-6-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-3-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgHandRash as HandRash };
